import {get} from "../utils";
import {getActiveChannel} from "../authentication/utils";

export default host => (channelId) =>
  get(`${host}/channels/${channelId}/elements/metadata?include=translations${getActiveChannel() ? `&cLang=${localStorage.getItem("default_language")}` : ""}`)
    .then(response => response.json())
    .then(json => json.data)
